<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_client_setting_confirming'">
                </div>
                <hr class="dialog-hr">
                <div v-if="confirmInfo.connect" class="dialog-body">
                    <div v-if="confirmInfo.linkType === 0"
                         v-html="$t('message.info_send_allow_link_request', { tenantName: confirmInfo.tenantName })"></div>
                    <div v-else>
                        <div v-if="confirmInfo.allowCheck">
                            <div v-html="$t('message.info_confirm_link_connect')"></div>
                            <div
                                class="terms-of-c2c-feature"
                            >
                                <p class="terms-of-c2c-feature__note2">{{
                                        $t("message.info_allow_request_note2_with_tenant_name", {tenantName: confirmInfo.tenantName})
                                    }}</p>
                                <div class="terms-of-c2c-feature__list">
                                    <p
                                        class="terms-of-c2c-feature__list-item"
                                    >
                                        ・{{ $t("message.info_allow_request_note2_list_item_1") }}
                                    </p>
                                    <p
                                        class="terms-of-c2c-feature__list-item"
                                    >
                                        ・{{ $t("message.info_allow_request_note2_list_item_2") }}
                                    </p>
                                </div>
                            </div>
                            <div class="terms-of-c2c-feature__confirm" v-t="'message.info_confirm_action'"></div>
                        </div>
                        <div v-else
                             v-html="$t('message.info_send_want_link_request', { tenantName: confirmInfo.tenantName })"></div>
                    </div>
                </div>
                <div v-else class="dialog-body" v-t="'message.info_link_disconnected'"></div>
                <hr class="dialog-hr">
                <div v-if="(confirmInfo.connect & confirmInfo.allowCheck)" class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('allowLink')">OK</el-button>
                </div>
                <div v-else class="dialog-button-field" style="text-align:center">
                    <el-button class="dialog-ok-button" style="width:160px" @click="$emit('confirm')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>

export default {
    data() {
        return {
        };
    },
    methods: {
    },
    components: {
    },
    created: function() {
    },
    props: [ 'confirmInfo' ]
}
</script>
<style scoped>
p {
    margin: 0;
}

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding: 20px;
    font-size: 14px;
}

.terms-of-c2c-feature {
    margin-top: 8px;
}

.terms-of-c2c-feature__list {
    margin-top: 4px;
}

.terms-of-c2c-feature__list-item {
    margin: 0;
}

.terms-of-c2c-feature__confirm {
    margin-top: 24px;
}

</style>
